import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]
  static values = {
    enabledLabel: { type: String, default: "Add Selected Items to Cart" },
    disabledLabel: { type: String, default: "Select an item to add to cart" }
  }

  connect() {
    this.updateSubmit()
  }

  updateSubmit() {
    const hasSelection = this.element.querySelectorAll(
      'input[type="checkbox"][name^="included_rows"]:checked'
    ).length > 0

    this.submitTargets.forEach(button => {
      button.disabled = !hasSelection
      button.value = hasSelection ? this.enabledLabelValue : this.disabledLabelValue
    })
  }
}
